import { IInitialState } from "./types";

export const initialState: IInitialState = {
  products: {
    params: {
      page: 1,
      pageSize: 10,
      marathonId: null,
      productCategoryId: null
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  productsById: {
    params: {
      marathonId: null,
      products: null,
      quantities: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  product: {
    data: null,
    loading: false,
    error: null,
  },
  productByProductId: {
    params: {
      productId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  userMarathonProducts: {
    params: {
      marathonId: null,
      userId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  updateProduct: {
    data: null,
    loading: false,
    error: null,
  },
  deleteProduct: {
    data: null,
    loading: false,
    error: null,
  }
};
